// state.error is a translation key, or { key, values } when the API sent interpolation values.
export function translateSetupError(t, error) {
  if (!error) return null
  if (typeof error === 'string') return t(error)
  if (error.key) return t(error.key, error.values)
  return error
}
